import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Customer } from '../models/customer';


@Injectable()
export class CustomerService {

  customersCollection: AngularFirestoreCollection<Customer>;
  customers: Observable<Customer[]>;
  customerDoc: AngularFirestoreDocument<Customer>;

  constructor(public afs: AngularFirestore) {
    // the value passed in should EXACTLY match the collection name in firestore or it wont pull data.
    // example - in this case 'customers' with a lower case c would not work because it is named 'Customers'
    
    this.customersCollection = this.afs.collection('Customers', ref => ref.orderBy('firstName', 'asc'));

    this.customers = this.customersCollection.snapshotChanges().map(changes => {
      return changes.map(param => {
        const data = param.payload.doc.data() as Customer;
        data.id = param.payload.doc.id;
        return data;
      });
    });
  }

  getCustomers() {
    return this.customers;
  }

  addCustomer(customer: Customer) {
    this.customersCollection.add(customer);
  }

  deleteCustomer(customer: Customer) {
    this.customerDoc = this.afs.doc(`Customers/${customer.id}`);
    this.customerDoc.delete();
  }

  updateCustomer(customer: Customer) {
    this.customerDoc = this.afs.doc(`Customers/${customer.id}`);
    this.customerDoc.update(customer);
  }
}


// Need to use snapshotChanges instead of valueChanges to be able to retrieve the ID from a collection document
// To just return regularly without the ID of the customer: Below Code

// constructor(public afs: AngularFirestore) {
//   this.customers = this.afs.collection('Customers').valueChanges(); 
// }


// WEBPACK FOOTER //
// ./src/app/services/customer.service.ts